import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExplosion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExplosion"><Path d="M12 2.5L14.1813 6.73389L18.7175 5.28249L17.2661 9.8187L21.5 12L17.2661 14.1813L20.5 20.5L14.1813 17.2661L12 21.5L9.8187 17.2661L5.28249 18.7175L6.73389 14.1813L2.5 12L6.73389 9.8187L3.5 3.5L9.8187 6.73389L12 2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconExplosion;
